import { tv } from "@tameeni/shared-logic";
const fileUploaderVariants = tv({
  slots: {
    root: "group  transition duration-300 relative flex border-[1px] border-slate-300 rounded-xl min-h-5xl px-xl py-sm items-center gap-2 w-full bg-white",
    input: "absolute inset-0 opacity-0 cursor-pointer z-20 w-full h-full",
    label: "transition z-10 text-b2 text-slate-500 pl-2 pointer-events-none",
    uploadIcon: "absolute end-xl top-0 bottom-0 m-auto text-slate-600 z-10",
    fileList: "flex flex-wrap gap-2 mt-4",
    fileItem: "flex items-center gap-2 rounded-xs px-2 py-1 text-b3  min-w-0 max-w-xs bg-slate-100",
    description: "mt-2 text-s3 text-slate-600"
  },
  variants: {
    error: {
      true: {
        root: "!border-red-500",
        label: "!text-red-500"
      }
    },
    success: {
      true: {
        root: "!border-green-600 !bg-green-100"
      }
    },
    dragActive: {
      true: {
        root: "!border-blue-600 !bg-blue-50"
      }
    },
    hasFiles: {
      true: {
        label: "-translate-y-5 text-b3 text-slate-500 absolute"
      }
    },
    loading: {
      true: {
        root: "!border-slate-400 !bg-slate-50 cursor-not-allowed",
        label: "!text-slate-400",
        input: "cursor-not-allowed"
      }
    }
  }
});
export {
  fileUploaderVariants as default
};
